import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Calendar, MapPin, Users, Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const EventDetails = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvent();
  }, [id]);

  const fetchEvent = async () => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/events/${id}`);
      setEvent(response.data);
    } catch (error) {
      toast.error('Failed to load event');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="section-padding flex justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div></div>;
  }

  if (!event) {
    return <div className="section-padding text-center">Event not found</div>;
  }

  return (
    <div className="section-padding">
      <div className="container-custom max-w-4xl">
        <div className="card p-8">
          <h1 className="text-4xl font-bold mb-6">{event.title}</h1>
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div className="flex items-center text-gray-600">
              <Calendar className="mr-3" />
              {new Date(event.event_date).toLocaleDateString('en-IN', { 
                dateStyle: 'full' 
              })}
            </div>
            <div className="flex items-center text-gray-600">
              <Clock className="mr-3" />
              {new Date(event.event_date).toLocaleTimeString('en-IN', { 
                timeStyle: 'short' 
              })}
            </div>
            <div className="flex items-center text-gray-600">
              <MapPin className="mr-3" />
              {event.location}
            </div>
            <div className="flex items-center text-gray-600">
              <Users className="mr-3" />
              {event.registered_count} / {event.max_volunteers} Volunteers
            </div>
          </div>

          <div className="prose max-w-none mb-8">
            <p className="text-gray-700">{event.description}</p>
          </div>

          {user ? (
            <button className="btn btn-primary w-full">Register for Event</button>
          ) : (
            <p className="text-center text-gray-600">
              Please <a href="/login" className="text-primary underline">login</a> to register for this event
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
